import React, { useState, useRef, useEffect } from "react";
import { PayData } from "./../data/payData";
import Input from "./input";
import upload from "../../components/assets/images/upload.jpg";
import { toast } from "react-toastify";
import postService from "../services/postService";

const Payment = ({ pay, payment_status, userType, handlePayment }) => {
  const [open, setOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(
    userType === "Seller" ? null : 0
  );
  const [currentTrack, setCurrentTrack] = useState([]);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [payment, setPayment] = useState({
    status: payment_status,
    remarks: "",
    traker_img: "",
    amount: "",
  });

  const fetchTrack = async (pay) => {
    let array3 = PayData.filter(
      (obj2) => !pay.some((obj1) => obj1.title === obj2.steps)
    );
    setCurrentTrack(array3);
  };

  useEffect(() => {
    if (pay) fetchTrack(pay);
  }, [pay]);

  const handleChange = ({ currentTarget: input }) => {
    const payments = { ...payment };
    payments[input.name] = input.value;
    setPayment(payments);
  };

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);

    const reader = new FileReader();
    reader.onloadend = () => {
      setFileUrl(reader.result);
      let string = reader.result;
      let spilitFile = string.split(",");
      let resultedString = spilitFile[1];
      setPayment({ ...payment, traker_img: resultedString });
    };

    reader.readAsDataURL(selectedFile);
  };

  const handleImage = (item) => {
    inputRef.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        ...payment,
        steps: currentTrack[0].steps,
        order_id: pay[0].order_id,
        seller_id: pay[0].seller_id,
        buyer_id: pay[0].buyer_id,
      };
      handlePayment(data);
      setOpen(!open);
    } catch (error) {
      toast.error(error);
    }
  };

  function formatDate(date) {
    let currentDate = new Date(date);
    let dateString = currentDate.toDateString(); // "Tue Feb 07 2023"
    return dateString;
  }

  function formatTime(date) {
    let currentTime = new Date(date);
    let timeString = currentTime.toLocaleTimeString(); // "12:00:00 AM"
    return timeString;
  }

  const badgeClass = (status) => {
    if (status === "Advance") {
      return "text-bg-primary";
    } else if (status === "Partial") {
      return "text-bg-warning";
    }
    if (status === "Paid") {
      return "text-bg-success";
    } else {
      return "text-bg-danger";
    }
  };

  const formatter = new Intl.NumberFormat("hi", {
    style: "currency",
    currency: "INR",
  });

  const inputRef = useRef();

  const { remarks, status, amount } = payment;
  const currentDate = new Date();

  return (
    <>
      <span
        className={`badge rounded-pill ${badgeClass(status)}`}
        style={{ cursor: "pointer" }}
        onClick={() => setOpen(!open)}
      >
        {status}
      </span>
      <div
        className={open ? "modal fade show" : "modal fade"}
        style={{ display: open ? "block" : "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Payment Status
              </h1>
              <button
                type="button"
                className="btn-close"
                onClick={() => setOpen(!open)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                {pay.map((item, index) => (
                  <>
                    <div className={`order-tracking completed p-1`}>
                      <button
                        className="is-complete"
                        onClick={() => setCurrentStep(index)}
                      ></button>
                      <div className="order-status">
                        <p>{item.title}</p>
                        <p>{item.created_date}</p>
                        <p>Payment of {formatter.format(item.amount)}</p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>
                            <i class="fa fa-calendar" /> Date:{" "}
                            {formatDate(item.created_date)}{" "}
                          </span>
                          <span>
                            <i className="fa fa-clock-o" /> Time:{" "}
                            {formatTime(item.created_date)}
                          </span>
                        </p>
                        <p style={{ textAlign: "justify" }}>{item.remarks}</p>
                      </div>
                      <div className="order-image">
                        {item.img1 === "" ||
                          (item.img1 !== null && (
                            <>
                              <img
                                style={{ width: "100px", height: "100px" }}
                                src={item.img1}
                                alt="Onclq.com"
                              />
                            </>
                          ))}
                      </div>
                    </div>
                  </>
                ))}

                {currentTrack.map((item, index) => (
                  <>
                    <div
                      className={`order-tracking ${
                        index <= currentStep ? "completed" : ""
                      } p-1`}
                    >
                      <button
                        type="button"
                        disabled={index === currentStep ? false : true}
                        className="is-complete"
                        onClick={() => setCurrentStep(index)}
                      ></button>
                      <div className="order-status">
                        <p>{item.steps}</p>
                        {/* <p>{item.date}</p> */}
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>
                            <i class="fa fa-calendar" /> Date:{" "}
                            {formatDate(currentDate)}{" "}
                          </span>
                          <span>
                            <i className="fa fa-clock-o" /> Time:{" "}
                            {formatTime(currentDate)}
                          </span>
                        </p>
                        <p
                          style={{
                            display: index === currentStep ? "none" : "block",
                            textAlign: "justify",
                          }}
                        >
                          {item.remarks}
                        </p>
                        <div
                          className="col-md-12 mt-2"
                          style={{
                            display:
                              index === currentStep && userType === "Buyer"
                                ? "block"
                                : "none",
                          }}
                        >
                          <Input
                            name="amount"
                            value={amount}
                            label="Amount"
                            type="number"
                            placeholder="Enter Amount"
                            onChange={handleChange}
                          />
                          <label for="bid_specification" className="form-label">
                            Remarks you want to add.
                          </label>
                          <textarea
                            className="form-control"
                            rows="2"
                            name="remarks"
                            value={remarks}
                            placeholder="Your Remarks here...."
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="order-image">
                        {fileUrl && (
                          <img
                            src={index === currentStep ? fileUrl : upload}
                            style={{
                              display:
                                index === currentStep && userType === "Buyer"
                                  ? "block"
                                  : "none",
                              width: "100px",
                              height: "100px",
                            }}
                            alt="Preview"
                          />
                        )}
                        {!fileUrl && (
                          <img
                            src={upload}
                            style={{
                              display:
                                index === currentStep && userType === "Buyer"
                                  ? "block"
                                  : "none",
                              width: "100px",
                              height: "100px",
                            }}
                            alt="Preview"
                          />
                        )}
                        <input
                          ref={inputRef}
                          style={{ display: "none" }}
                          accept="image/png, image/jpeg"
                          name="image"
                          label="Upload Image"
                          type="file"
                          onChange={(event) => handleFileSelect(event)}
                        />
                        <button
                          type="button"
                          style={{
                            display:
                              index === currentStep && userType === "Buyer"
                                ? "block"
                                : "none",
                          }}
                          className="btn btn-attach"
                          onClick={() => handleImage(item)}
                        >
                          <i className="fa fa-cloud-upload"></i> <br />
                          Upload Image
                        </button>
                      </div>
                    </div>

                    <div
                      className="order-button"
                      style={{
                        display:
                          index === currentStep && userType === "Buyer"
                            ? "flex"
                            : "none",
                      }}
                    >
                      <button type="submit" className="btn btn-success btn-sm">
                        {" "}
                        Save{" "}
                      </button>
                    </div>
                  </>
                ))}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
